export const initializeSystem = ({ commit }, payload) => {
  commit('INITIALIZE_SYSTEM', payload)
}
export const setShowChangelog = ({ commit }, payload) => {
  commit('SET_SHOW_CHANGELOG', payload)
}